<template>
  <div class="aziende-cercate-view">
    <button class="close-button" @click="close">×</button>
    <h2>Aziende Individuate<span v-if="filteredAziende.length > 0"> ({{ filteredAziende.length }})</span></h2>

    <!-- Filtro per categoria -->
    <div class="filter-container">
      <label for="categoria-filter">Filtra per categoria:</label>
      <div class="custom-select">
        <div class="selected-option" @click="toggleDropdown">
          {{ selectedCategoria || "Tutte le categorie" }}
        </div>
        <ul v-if="dropdownOpen" class="options-list">
          <li
            v-for="categoria in categorieUniche"
            :key="categoria"
            @click="selectCategoria(categoria)"
            class="option-item"
          >
            {{ categoria }}
          </li>
          <li @click="selectCategoria('')" class="option-item">Tutte le categorie</li>
        </ul>
      </div>
    </div>

    <!-- Lista delle aziende trovate -->
    <div class="results-container">
      <div v-if="filteredAziende.length > 0">
        <div v-for="azienda in filteredAziende" :key="azienda.PARTITA_IVA" class="azienda-item">
          <h3>{{ azienda.DNZ }}</h3>
          <p><b>Codice ATECO:</b> {{ azienda.CODICE }}</p>
          <p><b>Categoria:</b> {{ azienda.CATEGORIA }}</p>
          <p><b>Indirizzo:</b> {{ azienda.VIA }} {{ azienda.VIA_DENOMINAZIONE }} {{ azienda.NUMERO_CIVICO }}, {{ azienda.COMUNE }} ({{ azienda.PRV }})</p>
          <p><b>Partita IVA:</b> {{ azienda.PARTITA_IVA }}</p>
          <p><b>Email:</b> {{ azienda.EMAIL }}</p>
          <p><b>Telefono:</b> {{ azienda.TELEFONO }}</p>
          <p><b>Codice Fiscale:</b> {{ azienda.CODICE_FISCALE }}</p>
        </div>
      </div>
      <div v-else>
        <p>Nessuna azienda trovata.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AziendeTrovateView",
  props: {
    aziendeTrovateList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedCategoria: "", // Categoria selezionata
      dropdownOpen: false, // Stato del menu a discesa
    };
  },
  computed: {
    // Categorie uniche per il filtro
    categorieUniche() {
      return [...new Set(this.aziendeTrovateList.map((azienda) => azienda.CATEGORIA))];
    },
    // Lista filtrata delle aziende
    filteredAziende() {
      if (!this.selectedCategoria) {
        return this.aziendeTrovateList;
      }
      return this.aziendeTrovateList.filter(
        (azienda) => azienda.CATEGORIA === this.selectedCategoria
      );
    },
  },
  methods: {
    close() {
      this.$emit("closeAziendeTrovate");
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectCategoria(categoria) {
      this.selectedCategoria = categoria;
      this.dropdownOpen = false;
      this.filterAziende(); // Filtra le aziende
    },
    filterAziende() {
      const filteredList = this.filteredAziende; // Ottieni la lista filtrata
      this.$emit("filterAziende", filteredList); // Comunica la lista filtrata al genitore
    },
  },
};
</script>

<style scoped>
.aziende-cercate-view {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.filter-container {
  margin-bottom: 20px;
}

.custom-select {
  position: relative;
  width: 100%;
  max-width: 345px;
}

.selected-option {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.options-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: white;
  z-index: 1;
  max-height: 200px;
  overflow-y: auto;
  background-color: aliceblue;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Aggiunge un'ombra */
  list-style: none; /* Rimuove i punti elenco */
  padding: 0; /* Rimuove il padding predefinito */
  margin: 0; /* Rimuove il margine predefinito */
}

.option-item {
  padding: 10px; /* Aggiunge spazio interno */
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0; /* Aggiunge una linea divisoria tra le opzioni */
}

.option-item:last-child {
  border-bottom: none; /* Rimuove la linea divisoria per l'ultima opzione */
}

.option-item:hover {
  background: #f0f0f0; /* Cambia il colore di sfondo al passaggio del mouse */
}

.results-container {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
}

.azienda-item {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>